//import { projection } from '../projections/epgsg-21781.js';
import { projection } from '../projections/epgsg-3857.js';
import { applyStyle } from 'ol-mapbox-style';
import VectorTileLayer from 'ol/layer/VectorTile.js';
import VectorTileSource from 'ol/source/VectorTile.js';
import MVT from 'ol/format/MVT.js';
import { buffer } from 'ol/extent.js';
import { relief } from './relief.js';
import { config } from 'config';

/**
 * @module layers/water
 * @type {Object}
 */
export const water = {

  /**
   * {VectorTileLayer}
   */
  layer: null,

  /**
   * Creates the relief layer.
   * @return {water}
   */
  init () {
    // to have the same interface among all layers
    this.layer = this._get();
    return this;
  },

  /**
   * Create and return the relief vector layer.
   * @returns {VectorTileLayer}
   */
  _get () {
    const layer = new VectorTileLayer({
      source: new VectorTileSource({
        format: new MVT(),
        url: 'https://vectortiles.geo.admin.ch/tiles/ch.swisstopo.base.vt/v1.0.0/{z}/{x}/{y}.pbf'
      }),
      extent: buffer(projection.extent, relief.BUFFER_SIZE),
      zIndex: config.layerZIndex.water
    });
    applyStyle(layer, 'https://vectortiles.geo.admin.ch/styles/ch.swisstopo.basemap.vt/style.json',
      ['water_line_intermittent', 'water_line', 'water', 'water_outlines']
    );

    return layer;
  }
};